import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import InputItem from "../../../app/generic/form/inputItem";
import SelectItem from "../../../app/generic/form/selectItem";

export const defaultMaturities = [
  { code: "Weekly", name: "" },
  { code: "Monthly", name: "" },
];

export const initialPlaceOfSign = "Ostrava",
  initialPlaceOfSignType = 1,
  differentPlaceOfSign = 2;

export const parseFurtherInformationForm = (values) => ({
  placeOfSign: values.placeOfSign,
  maturity: values.maturity,
});

export const parseInitialFurtherInformationForm = (contract) => ({
  placeOfSign: contract.placeOfSign || initialPlaceOfSign,
  maturity: contract.maturity || defaultMaturities[0].code,
  placeOfSignType:
    contract.placeOfSign === initialPlaceOfSign ? initialPlaceOfSign : 2,
});

export const getDefaultFurtherInformationForm = () => ({
  ...parseInitialFurtherInformationForm({}),
  placeOfSignType: initialPlaceOfSignType,
});

const FurtherInformation = ({ legalEntity, formItemLayout }) => {
  const intl = useIntl();

  const [maturities, setMaturities] = useState();
  useEffect(() => {
    setMaturities(
      defaultMaturities.map((m) => ({
        ...m,
        name: intl.formatMessage({
          id: `registration.maturity.${m.code.toLowerCase()}`,
          defaultMessage: m.code,
        }),
      }))
    );
  }, [intl]);

  /*const [different, setDifferent] = useState();
  const handleTypeChange = useCallback((e) => {
    setDifferent(e.target.value === differentPlaceOfSign);
  }, []);*/

  return (
    <>
      {maturities && (
        <SelectItem
          required
          disabled
          fieldName="maturity"
          options={maturities}
          formItemLayout={formItemLayout}
          label={
            <FormattedMessage
              id="registration.maturity"
              defaultMessage="Splatnost faktury"
            />
          }
        />
      )}
      {/* <RadioGroupItem
        required
        size="large"
        fieldName="placeOfSignType"
        onChange={handleTypeChange}
        formItemLayout={formItemLayout}
        label={
          <FormattedMessage
            id="registration.placeOfSign"
            defaultMessage="Místo podpisu"
          />
        }
        options={[
          {
            id: initialPlaceOfSignType,
            name: legalEntity ? (
              <FormattedMessage
                id="registration.placeOfSign.place"
                defaultMessage="sídlo příkazce"
              />
            ) : (
              <FormattedMessage
                id="registration.placeOfSign.home"
                defaultMessage="trvalé bydliště"
              />
            ),
          },
          {
            id: differentPlaceOfSign,
            name: (
              <FormattedMessage
                id="registration.placeOfSign.different"
                defaultMessage="jiné"
              />
            ),
          },
        ]}
      /> */}
      <InputItem
        required
        disabled
        allowClear
        fieldName="placeOfSign"
        formItemLayout={formItemLayout}
        label={
          <FormattedMessage
            id="registration.placeOfSign"
            defaultMessage="Místo podpisu"
          />
        }
      />
    </>
  );
};

export default FurtherInformation;
